import React from 'react';
import I18n from 'i18n-js';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

import UserPrivacySettingModal from './user_privacy_setting_modal';

const COMPONENT_NAME = 'UserPrivacySetting';

export default function UserPrivacySetting() {
  const { thirdPartyAdDataAllowed } = useUser();
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [isChecked, setPrivacySetting] = React.useState(thirdPartyAdDataAllowed);

  const closeModal = React.useCallback(() => {
    setModalOpen(false);
  }, []);

  const openModal = React.useCallback(() => {
    setModalOpen(true);

    trackEvent({
      eventName: MParticleEventName.OpenedPrivacySettingsModal,
      componentName: COMPONENT_NAME,
    });
  }, []);

  const updatePrivacySetting = React.useCallback((e) => {
    setPrivacySetting(e.target.checked);
  }, []);

  return (
    <button
      type="button"
      className="site-footer-v2__link"
      onClick={openModal}
    >
      <UserPrivacySettingModal
        isChecked={isChecked}
        updatePrivacySetting={updatePrivacySetting}
        onClose={closeModal}
        isOpen={isModalOpen}
      />
      {I18n.t('discovery.privacySettingsModal.privacySettings.title')}
    </button>
  );
}
